import { ApiErrorResponse, ApiResult } from "../models/ApiResponse";
import i from "../utils/locale/i18n";

export function success<T>(data: T, status?: number): ApiResult<T> {
	return {
		success: true,
		status: status || 200,
		data,
	};
}

export function failure<T>(errorResponse: ApiErrorResponse): ApiResult<T> {
	const { status, error } = errorResponse;
	return {
		success: false,
		status,
		error,
	};
}

export const createUpdateConsultantReadableError = (code?: string): string => {
	if (code) {
		if (code.includes("ID_NOT_UNIQUE"))
			return i.t("translation:PROVIDED_CONSULTANT_EMAIL_ALREADY_EXISTS");
		return code;
	}
	return i.t("translation:SOMETHING_WENT_WRONG");
};

/**
 * Extra readable detail for a batch customer error, appended to the issue type
 * label: which field a DELIVERY_METHOD_INCOMPLETE customer lacks.
 */
export const createInvoiceBatchIssueDetail = (issue: {
	code: string;
	field?: string;
}): string | undefined => {
	if (issue.code === "DELIVERY_METHOD_INCOMPLETE" && issue.field)
		return i.t(`translation:deliveryMethod.field.${issue.field}` as any);
	return undefined;
};

export const createInvoiceBatchRowReadableError = (errorDetail?: string): string => {
	if (errorDetail) {
		if (errorDetail.includes("VAT must be >= 0")) return i.t("translation:VAT_MUST_BE_POSITIVE");
		return errorDetail;
	}
	return i.t("translation:SOMETHING_WENT_WRONG");
};
